 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","home":"home","dashboard":"dashboard","donate":"donate","login":"login"}[chunkId]||chunkId) + "." + {"404":"3dafde31","chunk-01363591":"e33ed87c","chunk-0a3a6b76":"6f3d387a","chunk-1b72730e":"3bbc72d5","chunk-2292c542":"4f9a52cd","chunk-2d0ab64d":"549d7287","chunk-2d0c518d":"1e00a82d","chunk-2d213ae9":"5aecf0f0","chunk-2d231044":"89509d3c","chunk-2eabe5f4":"d98ceb19","chunk-59458615":"c285854a","chunk-2e891b6a":"f2a31a24","chunk-2f5a859f":"aaa6d8b2","chunk-34a409ba":"030b76f1","chunk-45054de3":"cf9d2a2c","chunk-46216e20":"34fec3b0","chunk-3ff76c05":"9e451417","chunk-9b24fb9c":"eb3752b3","chunk-47dc0563":"31396767","chunk-498801f0":"0f85bbac","chunk-4b7f405e":"17d26d22","chunk-4ff554f5":"1e01e275","chunk-54b75f6a":"e45be297","chunk-5c0d1206":"f8c22a39","chunk-5d2be4f6":"2a2e35d4","chunk-446740cf":"70bd6c7a","chunk-6bd9a07c":"d856e781","chunk-7d6b07e9":"0736c0ae","home":"b1aaa9a6","chunk-640279ca":"7843a8c5","chunk-652f9f1d":"7c4799c1","chunk-69e43c02":"476f2b40","chunk-6e83591c":"620f616a","chunk-81f966a8":"9938b436","chunk-13d480fb":"f26a8da3","chunk-176b269e":"9d9dae15","chunk-26158f68":"aa625510","chunk-7d46543c":"e3c45d02","chunk-9251df12":"30e6b027","chunk-58bc4503":"092faaaa","chunk-5cf60b45":"9179160d","chunk-79f8d868":"e8e74180","chunk-ed07d586":"d2764260","chunk-198d02d1":"f90bd08a","chunk-1fe96d26":"2d926003","chunk-2f77bcb2":"a0702eae","chunk-44fbd05f":"cc2c882e","chunk-4ca6e694":"453aba88","chunk-67a2ec96":"6b434233","chunk-6fe6d921":"45ece331","chunk-7122dce0":"7ffcf2ce","chunk-74076db7":"5eacaae1","chunk-801bef9e":"bf87032c","dashboard":"37c7caa7","chunk-8c749400":"5c21b855","chunk-9e91e83e":"574f2dd5","chunk-bee8a55a":"1212cf3d","chunk-da464af4":"c929096b","chunk-6efd5be0":"909da463","chunk-6f0d417e":"d03253d1","chunk-77332dfc":"72ac77c2","chunk-7e72a780":"b74f4c41","chunk-7ea57887":"f64168e9","chunk-840aa5da":"2b3ae8c3","chunk-999790c4":"ac186728","chunk-b494f408":"8b5997a2","chunk-cc2a3df6":"92f898cb","chunk-ccf8dd34":"956f3792","chunk-d4afef94":"68991867","chunk-d7f59bfe":"26036a27","chunk-ea1c6e9c":"6fd32117","chunk-f6a3af2a":"8f5f5f06","donate":"a4c0a7bc","login":"c1be0d6c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"chunk-01363591":1,"chunk-0a3a6b76":1,"chunk-1b72730e":1,"chunk-2292c542":1,"chunk-2eabe5f4":1,"chunk-59458615":1,"chunk-2e891b6a":1,"chunk-2f5a859f":1,"chunk-34a409ba":1,"chunk-45054de3":1,"chunk-3ff76c05":1,"chunk-9b24fb9c":1,"chunk-47dc0563":1,"chunk-498801f0":1,"chunk-4b7f405e":1,"chunk-4ff554f5":1,"chunk-54b75f6a":1,"chunk-5c0d1206":1,"chunk-6bd9a07c":1,"chunk-7d6b07e9":1,"home":1,"chunk-640279ca":1,"chunk-652f9f1d":1,"chunk-69e43c02":1,"chunk-81f966a8":1,"chunk-13d480fb":1,"chunk-176b269e":1,"chunk-26158f68":1,"chunk-7d46543c":1,"chunk-9251df12":1,"chunk-58bc4503":1,"chunk-5cf60b45":1,"chunk-79f8d868":1,"chunk-198d02d1":1,"chunk-1fe96d26":1,"chunk-2f77bcb2":1,"chunk-44fbd05f":1,"chunk-4ca6e694":1,"chunk-67a2ec96":1,"chunk-6fe6d921":1,"chunk-7122dce0":1,"chunk-74076db7":1,"chunk-801bef9e":1,"dashboard":1,"chunk-8c749400":1,"chunk-9e91e83e":1,"chunk-bee8a55a":1,"chunk-da464af4":1,"chunk-6f0d417e":1,"chunk-77332dfc":1,"chunk-7e72a780":1,"chunk-7ea57887":1,"chunk-840aa5da":1,"chunk-999790c4":1,"chunk-b494f408":1,"chunk-cc2a3df6":1,"chunk-ccf8dd34":1,"chunk-d4afef94":1,"chunk-d7f59bfe":1,"chunk-ea1c6e9c":1,"chunk-f6a3af2a":1,"login":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","home":"home","dashboard":"dashboard","donate":"donate","login":"login"}[chunkId]||chunkId) + "." + {"404":"2189cf26","chunk-01363591":"42a58438","chunk-0a3a6b76":"e3862ff6","chunk-1b72730e":"b1dbd5f2","chunk-2292c542":"7b2c954b","chunk-2d0ab64d":"31d6cfe0","chunk-2d0c518d":"31d6cfe0","chunk-2d213ae9":"31d6cfe0","chunk-2d231044":"31d6cfe0","chunk-2eabe5f4":"516273cf","chunk-59458615":"fd5c7958","chunk-2e891b6a":"c6e558f1","chunk-2f5a859f":"4b8672e6","chunk-34a409ba":"6c400c94","chunk-45054de3":"42db1812","chunk-46216e20":"31d6cfe0","chunk-3ff76c05":"f93cfa9f","chunk-9b24fb9c":"71ba5116","chunk-47dc0563":"2987e079","chunk-498801f0":"c2d78980","chunk-4b7f405e":"67b7d38a","chunk-4ff554f5":"5e5a9dc3","chunk-54b75f6a":"6e7f4a17","chunk-5c0d1206":"acfac5ad","chunk-5d2be4f6":"31d6cfe0","chunk-446740cf":"31d6cfe0","chunk-6bd9a07c":"aa2267ff","chunk-7d6b07e9":"3245f6f8","home":"ab11c850","chunk-640279ca":"9a36d6ac","chunk-652f9f1d":"e194c85b","chunk-69e43c02":"fc14c304","chunk-6e83591c":"31d6cfe0","chunk-81f966a8":"a48a7cc1","chunk-13d480fb":"32d8f9c5","chunk-176b269e":"d82677d2","chunk-26158f68":"38574633","chunk-7d46543c":"b0c856ca","chunk-9251df12":"104fedf9","chunk-58bc4503":"dcca36a3","chunk-5cf60b45":"ffe13998","chunk-79f8d868":"7eaed008","chunk-ed07d586":"31d6cfe0","chunk-198d02d1":"3b169d6a","chunk-1fe96d26":"582d02e7","chunk-2f77bcb2":"e008cb6d","chunk-44fbd05f":"71635692","chunk-4ca6e694":"bcf32029","chunk-67a2ec96":"d6c46bdd","chunk-6fe6d921":"f534cc8c","chunk-7122dce0":"8b42231d","chunk-74076db7":"bb1361d3","chunk-801bef9e":"97858523","dashboard":"ba8411d7","chunk-8c749400":"29a5847c","chunk-9e91e83e":"1da660b4","chunk-bee8a55a":"465cb87b","chunk-da464af4":"8a738913","chunk-6efd5be0":"31d6cfe0","chunk-6f0d417e":"ff798832","chunk-77332dfc":"daf02889","chunk-7e72a780":"dd1594e0","chunk-7ea57887":"ccfe4350","chunk-840aa5da":"f4e20ac1","chunk-999790c4":"342df0c6","chunk-b494f408":"aa651bd6","chunk-cc2a3df6":"6f0b8116","chunk-ccf8dd34":"b2adaab4","chunk-d4afef94":"6ca2a0e0","chunk-d7f59bfe":"937f1666","chunk-ea1c6e9c":"6e6b6cd6","chunk-f6a3af2a":"6890223a","donate":"31d6cfe0","login":"c9bb805e"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
